<template>
  <div class="role">
    <div class="card-container">
      <div class="card-title">
        异常数据筛选
      </div>
      <div class="card-content">
        <a-form :form="form" @submit="handleSubmit">
          <a-row>
            <a-col class="search-item" :span="5">
              <a-form-item
                :label-col="{ span: 5 }"
                :wrapper-col="{ span: 19 }"
                label="区域"
              >
                <a-cascader
                  v-model="region"
                  :options="options"
                  :load-data="loadData"
                  change-on-select
                  :field-names="{
                    label: 'name',
                    value: 'id',
                    children: 'children'
                  }"
                  placeholder="省市区、街道"
                  @change="changeArea"
                />
              </a-form-item>
            </a-col>
            <a-col class="search-item" :span="5">
              <a-form-item
                :label-col="{ span: 5 }"
                :wrapper-col="{ span: 19 }"
                label="小区"
              >
                <a-select
                  v-decorator="[
                    'community',
                  ]"
                  allow-clear
                  show-search
                  placeholder="请选择"
                  option-filter-prop="children"
                  :filter-option="filterOption"
                >
                  <a-select-option
                    v-for="(item, index) in estateList"
                    :key="index"
                    :value="item.id"
                  >
                    {{ item.housingEstate }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col class="search-item" :span="5">
              <a-form-item
                :label-col="{ span: 5 }"
                :wrapper-col="{ span: 19 }"
                label="设备类型"
              >
                <a-select
                  v-decorator="[
                    'thingtype',
                    {initialValue: ''}
                  ]"
                >
                  <a-select-option value="">
                    全部
                  </a-select-option>
                  <a-select-option value="2">
                    智能分类站
                  </a-select-option>
                  <a-select-option value="4">
                    智能垃圾房
                  </a-select-option>
                  <a-select-option value="1">
                    智能回收站
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col class="search-item" :span="4" align="right">
              <a-form-item>
                <a-button type="primary" class="mr8" html-type="submit">
                  查询
                </a-button>
                <a-button @click="resetForm">
                  重置
                </a-button>
              </a-form-item>
            </a-col>
          </a-row>
        </a-form>
      </div>
    </div>
    <div class="card-container mrt16">
      <a-row>
        <a-col :span="12">
          <div class="card-title">
            投递异常分析
          </div>
        </a-col>
      </a-row>
      <div class="card-content">
        <a-table
          class="table-content"
          :columns="columns"
          :data-source="formData"
          :loading="loading"
          :pagination="pagination"
          :row-key="record => record.id"
          @change="handleTableChange"
        >
          <template slot="scenario" slot-scope="record">
            <span>{{ record|scenarioFl }}</span>
          </template>
          <template slot="operate" slot-scope="record">
            <a-button
              v-action:abnormal
              class="table-btn-link"
              type="link"
              size="small"
              @click="linkDetail(record)"
            >
              查看图片
            </a-button>
          </template>
        </a-table>
      </div>
      <a-drawer
        title="查看图片"
        placement="right"
        :closable="true"
        :header-style="{
          background:'#F4F5F7'
        }"
        :visible="imgvisible"
        width="970px"
        @close="onClose"
      >
        <div class="eject_content" style="width:100%">
          <div style="text-align:center;display: flex;justify-content: space-between;" class="eject_con">
            <a-radio-group
              v-model="changeValue" default-value="img" button-style="solid" style="    display: none;" @change="handleChange"
            >
              <a-radio-button value="img">
                图片
              </a-radio-button>
              <!-- <a-radio-button value="video">
                视频
              </a-radio-button> -->
            </a-radio-group>
            <a-form-item :label-col="{ span: 4 }" :wrapper-col="{ span: 19 }" label="选择日期:">
              <a-range-picker
                v-model="times" value-format="YYYY-MM-DD"
                @change="onTime"
              />
            </a-form-item>
          </div>
          <div>
            <a-spin :spinning="spinImg" tip="加载中...">
              <div v-show="changeValue === 'img'" class="pic">
                <div v-if="imgdata && imgdata.length !== 0">
                  <div v-for="(item,index) in imgdata" :key="index">
                    <div class="pic_top">
                      <div>
                        <span></span><span>{{ item.date }}</span>
                      </div>

                      <div v-if="item.photoList.length > 6" style="color: #1890ff;cursor: pointer" @click="toggle(item,item.date)">
                        <a-icon v-show="item.show" type="up" />
                        <a-icon v-show="!item.show" type="down" />
                        {{ item.show ? '收起': '展开' }}
                      </div>
                    </div>
                    <div class="pic_bot">
                      <!-- <viewer :images="item.photoList"> -->
                      <div>
                        <a
                          v-for="(imglt,inde) in item.photoList" v-if="inde < 6"
                          :key="inde" href="javascript:;" class="img_list" @click="imgTo(imglt,item.date)"
                        >
                          <!--<span style="position: absolute;top: 77px;left: 7px;color: #ffffff;">{{ imglt.createTime.substring(11,19) }}</span>
                          <span style="position:absolute;top:77px;right:7px"><img
                            style="width:100%;height:100%;" src="http://ito-boss-img.oss-cn-hangzhou.aliyuncs.com/material/20210707/162563854804933bd1d5f443b4dfc854900b623e37450.png" alt=""
                            srcset=""
                          ></span>
                          <span style="position: absolute;top: 0;left: 0;">
                            <span v-if="imglt.qualified === 0" style="color: #fff;">
                              <div class="qualified"></div>
                              <div class="spanText">合格</div>
                            </span>
                            <span v-else-if="imglt.qualified === 1" style="color: #fff;">
                              <div class="noqualified"></div>
                              <div class="spanText">不合格</div>
                            </span>
                            <span v-else></span>
                          </span>
                          -->

                          <img
                            :src="imglt.image + '?x-oss-process=image/resize,m_fill,w_650,h_350/quality,q_30'" :images="imglt.image" style="margin-bottom:20px"
                          >
                          <div class="viewer_cen">
                            <div style="font-size:12px">{{ imglt.alarmEvent }}</div></div>
                          <div style=" position: absolute;width:100%;    text-align: center;bottom: 42px;color: #fff;left: -30px;">{{ imglt.createTime }}</div>
                        <!-- <div class="viewer_bom">{{ imglt.alarmEvent }}</div> -->

                        </a>

                        <a
                          v-for="(imglt,inde) in item.photoList" v-show="item.show" v-if="inde >= 6" :key="inde" href="javascript:;" class="img_list" @click="imgTo(imglt,item.date)"
                        >

                          <img :src="imglt.image + '?x-oss-process=image/resize,m_fill,w_650,h_350/quality,q_30'" :images="imglt.image" style="margin-bottom:20px">
                          <div class="viewer_cen">
                            <div style="font-size:12px">{{ imglt.alarmEvent }}</div></div>
                          <div style=" position: absolute;width:100%;    text-align: center;bottom: 42px;color: #fff;left: -30px;">{{ imglt.createTime }}</div>

                        </a>
                      <!-- </viewer> -->
                      </div>
                    </div>
                    <a-divider />
                  </div>
                </div>
                <div v-else>
                  <a-empty />
                </div>
              </div>
            </a-spin>
            <div v-show="changeValue === 'video'" class="video" style="text-align: center;margin: 20px 0;">
              <!-- <video-player :videosrc="videoArr"></video-player> -->
              <div v-if="videoArr && videoArr.length !== 0">
                <template v-for="(item,index) in videoArr">
                  <iframe
                    v-if="item.src"
                    :key="index"
                    class="ysOpenDevice"
                    :src="item.src"
                    width="80%"
                    height="500"
                    allowfullscreen
                  >
                  </iframe>
                  <div v-else :key="index" class="ysOpenDevice">
                    {{ item.name + '(' + item.msg + ')' }}
                  </div>
                </template>
              </div>
              <div v-else>
                <a-empty />
              </div>
            </div>
          </div>
        </div>
      </a-drawer>
      <a-modal
        v-model="modelvisibless" :title="starttimes + ' ' +imgs.createTime" :footer="null"
        width="1300px"
      >
        <div class="modalimg" style="display: flex; justify-content: space-between;">
          <img :src="imgs.image" width="610px" height="100%">
          <img :src="imgs.image2" width="610px" height="100%">
        </div>
      </a-modal>
      <a-modal
        v-model="modelvisible" :title="starttime" :footer="null"
        width="1200px"
      >
        <div class="modalimg">
          <a-radio-group
            v-model="imgchoice" button-style="solid" default-value="a"
            @change="onChange"
          >
            <a-radio-button value="a">
              外部
            </a-radio-button>
            <a-radio-button value="b">
              内部
            </a-radio-button>
          </a-radio-group>
        </div>
        <a-spin :spinning="spinInOut" tip="加载中...">
          <div v-show="imgchoice === 'a'">
            <div
              style="display: flex;justify-content: space-between;margin-top: 45px;"
            >
              <div v-if="external.originalImg" style="position:relative;">
                <img
                  style="border-radius: 3%;" width="550px" height="300px"
                  :src="external.originalImg + '?x-oss-process=image/resize,m_fill,w_650,h_350/quality,q_30'"
                >
                <span style="position: absolute;top: 0;left: 0;">
                  <span v-if="external.qualified === 0" style="color: #fff;">
                    <div class="qualified"></div>
                    <div class="spanText">合格</div>
                  </span>
                  <span v-else-if="external.qualified === 1" style="color: #fff;">
                    <div class="noqualified"></div>
                    <div class="spanText">不合格</div>
                  </span>
                  <span v-else></span>
                </span>
                <div style="position: absolute;bottom: 25px;left: 50%;transform: translateX(-50%);">
                  <span style="color:#fff;padding:10px 20px;background:#00000078;border-radius:7px;">标准环境</span>
                </div>
              </div>
              <div v-if="external.redAreaImg" style="position:relative;">
                <img
                  style="border-radius: 3%;" width="550px" height="300px"
                  :src="external.redAreaImg + '?x-oss-process=image/resize,m_fill,w_650,h_350/quality,q_30'"
                >
                <span style="position: absolute;top: 0;left: 0;">
                  <span v-if="external.qualified === 0" style="color: #fff;">
                    <div class="qualified"></div>
                    <div class="spanText">合格</div>
                  </span>
                  <span v-else-if="external.qualified === 1" style="color: #fff;">
                    <div class="noqualified"></div>
                    <div class="spanText">不合格</div>
                  </span>
                  <span v-else></span>
                </span>
                <div style="position: absolute;bottom: 25px;left: 50%;transform: translateX(-50%);">
                  <span style="color:#fff;padding:10px 20px;background:#00000078;border-radius:7px;">框图</span>
                </div>
              </div>
            </div>
            <div style="display: flex;justify-content: center;margin-top: 40px;">
              <div v-if="external.hotImg" style="position:relative;">
                <img
                  style="border-radius: 3%;" width="550px" height="300px"
                  :src="external.hotImg + '?x-oss-process=image/resize,m_fill,w_650,h_350/quality,q_30'"
                >
                <span style="position: absolute;top: 0;left: 0;">
                  <span v-if="external.qualified === 0" style="color: #fff;">
                    <div class="qualified"></div>
                    <div class="spanText">合格</div>
                  </span>
                  <span v-else-if="external.qualified === 1" style="color: #fff;">
                    <div class="noqualified"></div>
                    <div class="spanText">不合格</div>
                  </span>
                  <span v-else></span>
                </span>
                <div style="position: absolute;bottom: 25px;left: 50%;transform: translateX(-50%);">
                  <span style="color:#fff;padding:10px 20px;background:#00000078;border-radius:7px;">热力图</span>
                </div>
              </div>
            </div>
          </div>
          <div v-show="imgchoice === 'b'">
            <div
              v-if="inside.originalImg || inside.redAreaImg" style="display: flex;justify-content: space-between;margin-top: 45px;"
            >
              <div v-if="inside.originalImg" style="position:relative;">
                <img
                  style="border-radius: 3%;" width="550px" height="300px"
                  :src="inside.originalImg + '?x-oss-process=image/resize,m_fill,w_650,h_350/quality,q_30'"
                >
                <span style="position: absolute;top: 0;left: 0;">
                  <span v-if="inside.qualified === 0" style="color: #fff;">
                    <div class="qualified"></div>
                    <div class="spanText">合格</div>
                  </span>
                  <span v-else-if="inside.qualified === 1" style="color: #fff;">
                    <div class="noqualified"></div>
                    <div class="spanText">不合格</div>
                  </span>
                  <span v-else></span>
                </span>
                <div style="position: absolute;bottom: 25px;left: 50%;transform: translateX(-50%);">
                  <span style="color:#fff;padding:10px 20px;background:#00000078;border-radius:7px;">标准环境</span>
                </div>
              </div>
              <div v-if="inside.redAreaImg" style="position:relative;">
                <img
                  style="border-radius: 3%;" width="550px" height="300px"
                  :src="inside.redAreaImg + '?x-oss-process=image/resize,m_fill,w_650,h_350/quality,q_30'"
                >
                <span style="position: absolute;top: 0;left: 0;">
                  <span v-if="inside.qualified === 0" style="color: #fff;">
                    <div class="qualified"></div>
                    <div class="spanText">合格</div>
                  </span>
                  <span v-else-if="inside.qualified === 1" style="color: #fff;">
                    <div class="noqualified"></div>
                    <div class="spanText">不合格</div>
                  </span>
                  <span v-else></span>
                </span>
                <div style="position: absolute;bottom: 25px;left: 50%;transform: translateX(-50%);">
                  <span style="color:#fff;padding:10px 20px;background:#00000078;border-radius:7px;">框图</span>
                </div>
              </div>
            </div>
            <div v-if="inside.hotImg" style="display: flex;justify-content: center;margin-top: 40px;">
              <div v-if="inside.hotImg" style="position:relative;">
                <img
                  style="border-radius: 3%;" width="550px" height="300px"
                  :src="inside.hotImg + '?x-oss-process=image/resize,m_fill,w_650,h_350/quality,q_30'"
                >
                <span style="position: absolute;top: 0;left: 0;">
                  <span v-if="inside.qualified === 0" style="color: #fff;">
                    <div class="qualified"></div>
                    <div class="spanText">合格</div>
                  </span>
                  <span v-else-if="external.qualified === 1" style="color: #fff;">
                    <div class="noqualified"></div>
                    <div class="spanText">不合格</div>
                  </span>
                  <span v-else></span>
                </span>
                <div style="position: absolute;bottom: 25px;left: 50%;transform: translateX(-50%);">
                  <span style="color:#fff;padding:10px 20px;background:#00000078;border-radius:7px;">热力图</span>
                </div>
              </div>
            </div>
            <div v-if="JSON.stringify(inside) === '{}'" style="display: flex;justify-content: center;align-items: center;min-height: 177px;">
              <a-empty />
            </div>
          </div>
        </a-spin>
      </a-modal>
    </div>
  </div>
</template>
<script>
import { getProductList, getWebcamAlarmPhoto, getPhotoList, getDeviceVideo } from '@/api/system'
import {
  getArea,
  getEstate,
  iconFontComponent
} from '@/components/mixins/mixins.js'
const columns = [
  {
    title: '区域名称',
    dataIndex: 'areaName',
    key: 'areaName'
  },
  {
    title: '街道名称',
    dataIndex: 'street'
  },
  {
    title: '小区名称',
    dataIndex: 'name',
    width: '380px'
  },
  {
    title: '设备类型',
    dataIndex: 'scenario',
    key: 'scenario',
    scopedSlots: { customRender: 'scenario' }
  },
  {
    title: '设备编号',
    dataIndex: 'productId',
    width: '300px'
  },
  {
    title: '操作',
    dataIndex: '',
    key: 'operate',
    width: '140px',
    fixed: 'right',
    scopedSlots: { customRender: 'operate' }
  }
]

export default {
  mixins: [getArea, getEstate, iconFontComponent],
  data () {
    return {
      spinImg: false,
      spinInOut: false,
      imgchoice: 'a',
      imgphoto: [],
      region: [],
      options: [],
      changeValue: 'img',
      imgvisible: false,
      imgdata: [],
      loading: false,
      userLoading: false,
      visible: false,
      columns,
      formData: [],
      modelvisible: false,
      modelvisibless: false,
      pagination: {
        current: 1,
        pageSize: 10,
        showSizeChanger: true,
        showQuickJumper: true,
        showTotal: total => '共' + total + '条记录',
        pageSizeOptions: ['10', '20', '30', '40'],
        defaultPageSize: 10,
        total: 0
      },
      external: {},
      inside: {},
      imgId: '',
      starttime: '',
      recordItem: {},
      videoArr: [],
      activeKey: '',
      showList: false,
      times: [],
      showMissionList2: false, // 日常任务列表展开收起开关
      imgs: '',
      starttimes: ''
    }
  },
  beforeCreate () {
    this.form = this.$form.createForm(this, {})
  },
  created: function () {
    this.getRoleList()
    this.getEstate()
    this.getArea('', 2)
  },

  methods: {
    imgTo (val, time) {
      this.imgs = val
      this.starttimes = time
      console.log(this.starttimes, ' this.starttimes')
      this.modelvisibless = true
    },
    inited (val) {
      console.log(val, '5556')
    },
    filterOption (input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      )
    },
    onChange (e) {
      this.spinInOut = true
      this.inside = {}
      const pamar = {
        id: this.imgId,
        type: e.target.value === 'b' ? 2 : 1
      }
      getPhotoList(pamar).then(res => {
        if (res.result.length !== 0) {
          this.inside = res.result[0]
          setTimeout(() => {
            this.spinInOut = false
          }, 1000)
        } else {
          this.spinInOut = false
        }
      })
      // if (e.target.value === 'b') {
      //   const pamar = {
      //     id: this.imgId,
      //     type: 2
      //   }
      //   getPhotoList(pamar).then(res => {
      //     if (res.result.length !== 0) {
      //       this.inside = res.result[0]
      //     }
      //   })
      // }
      // if (e.target.value === 'a') {
      //   const pamar = {
      //     id: this.imgId,
      //     type: 1
      //   }
      //   getPhotoList(pamar).then(res => {
      //     if (res.result.length !== 0) {
      //       this.inside = res.result[0]
      //     }
      //   })
      // }
    },
    viewImg (id, time) {
      this.external = {}
      const pamar = {
        id,
        type: 1
      }
      this.imgchoice = 'a'
      this.imgId = id
      this.starttime = time
      getPhotoList(pamar).then(res => {
        if (res.result.length !== 0) {
          this.external = res.result[0]
        }
      })
    },
    showModal () {
      this.modelvisible = true
      // this.imgvisible = false
      this.spinInOut = true
      setTimeout(() => {
        this.spinInOut = false
      }, 1000)
    },
    changeArea (areasId) {
      this.form.setFieldsValue({ estateId: undefined })
      if (areasId.length < 4) {
        this.getEstate(areasId)
      } else if (areasId.length === 4) {
        this.getEstate(null, areasId[3])
      }
    },
    getRoleList () {
      const params = {
        areaId: this.region[2] || '',
        cityId: this.region[1] || '',
        estateId: this.form.getFieldValue('community') || '',
        page: this.pagination.current,
        pageSize: this.pagination.pageSize,
        provinceId: this.region[0] || '',
        scenario: this.form.getFieldValue('thingtype') || ''
      }
      this.loading = true
      getProductList(params).then(res => {
        this.loading = false
        const result = res.result.list
        this.formData = result
        this.pagination.total = res.result.totalCount
      })
    },
    resetForm () {
      this.region = []
      this.form.resetFields()
      this.getEstate()
      this.getRoleList()
    },
    handleTableChange (pagination, filters, sorter) {
      const pager = { ...this.pagination }
      pager.current = pagination.current
      pager.pageSize = pagination.pageSize
      this.pagination = pager
      this.getRoleList()
    },
    handleSubmit (e) {
      e.preventDefault()
      this.form.validateFieldsAndScroll((err, values) => {
        if (!err) {
          this.pagination.current = 1
          this.getRoleList()
        }
      })
    },
    handleChange (e) {
      const val = e.target.value
      this.changeValue = val
      if (val === 'img') {
        this.linkDetail(this.recordItem)
      } else if (val === 'video') {
        this.getDeviceVideo(this.recordItem)
      }
    },
    getDeviceVideo ({ id }) {
      const params = {
        id: id
      }
      getDeviceVideo(params).then(res => {
        const arr = res.result
        this.videoArr = []
        arr.forEach(item => {
          if (item.state === 0) {
            this.videoArr.push({
              src: `https://open.ys7.com/ezopen/h5/iframe?url=${item.url}&autoplay=1&accessToken=${item.token}`
            })
          } else {
            this.videoArr.push({
              msg: item.msg,
              name: item.name
            })
          }
        })
      })
    },
    linkDetail (item) {
      this.spinImg = true
      this.changeValue = 'img'
      this.recordItem = item
      this.imgvisible = true
      // 现在的时间
      var dates = new Date()
      const year = dates.getFullYear()
      const mounth = (dates.getMonth() + 1).toString().padStart(2, '0')
      const day = dates.getDate().toString().padStart(2, '0')
      const time1 = year + '-' + mounth + '-' + day

      // 一周前的时间
      var time = (new Date()).getTime() - 6 * 24 * 60 * 60 * 1000
      var tragetTime = new Date(time)
      const tyear = tragetTime.getFullYear()
      const tmounth = (tragetTime.getMonth() + 1).toString().padStart(2, '0')
      const tday = tragetTime.getDate().toString().padStart(2, '0')
      const times = tyear + '-' + tmounth + '-' + tday
      this.times.push(times, time1)
      const params = {
        id: item.id,
        startTime: this.times[0],
        endTime: this.times[1]
      }
      getWebcamAlarmPhoto(params).then(res => {
        const arr = res.result
        // const imgurl = res.result[0].photoList
        // this.imgphoto = imgurl
        arr.forEach((val) => {
          val.show = false
        })
        this.imgdata = arr
        setTimeout(() => {
          this.spinImg = false
        }, 1000)
      })
    },
    onClose () {
      this.imgvisible = false
      this.times = []
      this.imgphoto = []
      this.imgdata = []
    },
    toggle (item) {
      item.show = !item.show
    },
    onTime (val) {
      this.times = val
      this.linkDetail(this.recordItem)
    }
  }
}
</script>

<style scoped>
.eject_con {
  text-align: center !important;
}
 /deep/ .ant-drawer-body {
    padding:24px 38px !important;
    margin: 0;
}
.viewer_cen {
width: 100%;
margin-left: 8px;
  position: absolute;
  background-color:rgba(0,0,0,0.35);
      /* background: #000000; */
      color: #fff;
    /* border-radius: 0px 0px 8px 8px; */
    /* opacity: 0.35; */
    top: 24px;
    left: -8px;
    text-align: center;
    /* left: 18px; */
    /* padding: 4px 7px; */
    padding: 4px 0;
}
.viewer_bom {
 position: absolute;
 color: #fff;
 top: 14px;
    left: 33px;
}
>>> .ant-form-item-label{
  text-align: left;
}
</style>
<style lang="stylus">
.ysOpenDevice
  margin-bottom 18px
.role-modal .ant-modal-footer
  text-align center
.del-modal .ant-btn-primary
  display none
</style>
<style lang="stylus" scoped>
.eject_content
  .pic
    .pic_top
      display flex
      justify-content: space-between;
      margin-bottom: 15px;
      margin-top: 20px;
      span:nth-child(1)
        width: 5px;
        height: 16px;
        background: #1890ff;
        margin-right: 10px;
    .pic_bot
      display: flex;
      margin-bottom: 20px;
      flex-wrap: wrap;
      .img_list
        margin 10px 8px
        position: relative;
        img
          width 130px
          height 100px
          border-radius 4%
.modalimg
  text-align center
.qualified
  background: linear-gradient(315deg, transparent 50%, rgba(38, 181, 71, 1) 0%);
  width: 50px;
  height: 50px;
  border-top-left-radius: 5px;
.noqualified
  background: linear-gradient(315deg, transparent 50%, rgba(215, 45, 32, 1) 0%);
  width: 50px;
  height: 50px;
  border-top-left-radius: 5px;
.spanText
  position absolute
  top 7px
  transform rotate(-45deg)
  font-size 12px
  font-weight 400
</style>
